import { FileDownload } from "@mui/icons-material";
import {
    Icon,
    ListItemIcon,
    ListItemText,
    MenuItem,
    MenuList,
} from "@mui/material";
import { useCallback, useState } from "react";
import { useAppSelector } from "redux/hooks";
import { StatusNotaFiscal, TMenuItemRelatorioProps } from "../vendas.model";
import "./MenuItems.css";

const initialState = {
  showImprimir: false as boolean,
};

const MenuItemFaturado = (props: TMenuItemRelatorioProps) => {
  const [stateLocal, setStateLocal] = useState(initialState);
  const configuracaoPoliticaVenda = useAppSelector(
    (e) => e.configuracoes.configuracaoPoliticaVenda,
  );

  const getConditionExcluirNota = useCallback(() => {
    const current = props.itemRef.current;
    const statusNF = current?.statusNotaFiscal;
    return (
      statusNF === StatusNotaFiscal.PENDENTE ||
      statusNF === StatusNotaFiscal.REJEITADA ||
      statusNF === StatusNotaFiscal.DENEGADA
    );
  }, [props.itemRef]);

  const isAutorizada = useCallback(() => {
    return props.itemRef.current?.statusNotaFiscal === "AUTORIZADA";
    //eslint-disable-next-line
  }, [props.itemRef]);

  const isEmProcessamento = useCallback(() => {
    return props.itemRef.current?.statusNotaFiscal === "EM PROCESSAMENTO";
    //eslint-disable-next-line
  }, [props.itemRef]);

  const isRejeitada = useCallback(() => {
    return props.itemRef.current?.statusNotaFiscal === "REJEITADA";
    //eslint-disable-next-line
  }, [props.itemRef]);

  const hasCrediario = useCallback(() => {
    return props.itemRef.current?.crediario;
    //eslint-disable-next-line
  }, []);

  const isNFCe = useCallback(() => {
    return props.itemRef.current?.modelo === "NFC-e";
    //eslint-disable-next-line
  }, []);

  const {
    canEditarVendedor = true,
    canCancelarDfe = true,
    canVisualizar = true,
    canImprimir = true,
    canImprimirPedido = true,
    canImprimirDanfe = true,
    canImprimirRomaneio = true,
    canImprimirEtiquetaVolume = true,
    canImprimirCrediario = true,
    canImprimirEtiquetaSimplificada = true,
    canAtualizarSituacao = true,
    canBaixarXml = true,
    canExcluirNota = true,
  } = props.acoes ?? {};

  return (
    <MenuList>
      {!isEmProcessamento() &&
        !isRejeitada() && [
          <MenuItem
            key="menu-item-aberto-cancelar-pedido"
            id="menu-item-aberto-cancelar-pedido"
            disabled={!canEditarVendedor}
            onClick={props.onEditarVendedor}
          >
            <ListItemIcon>
              <Icon className="fa-solid fa-pen" sx={{ fontSize: "16px" }} />
            </ListItemIcon>
            <ListItemText>Editar vendedor</ListItemText>
          </MenuItem>,

          <MenuItem
            key="menu-item-faturado-imprimir-dropdown"
            id="menu-item-faturado-imprimir-dropdown"
            disabled={!canImprimir}
            onClick={() =>
              setStateLocal((prevState) => ({
                ...prevState,
                showImprimir: !prevState.showImprimir,
              }))
            }
          >
            <ListItemIcon>
              <Icon className="fa-solid fa-print" sx={{ fontSize: "18px" }} />
            </ListItemIcon>
            <ListItemText>Imprimir</ListItemText>
            <Icon
              className={
                !stateLocal.showImprimir
                  ? "fa-solid fa-angle-down"
                  : "fa-solid fa-angle-up"
              }
              sx={{ fontSize: "18px" }}
            />
          </MenuItem>,

          <div
            key={"menu-items-container"}
            className={`menu-items-container ${stateLocal.showImprimir ? "opened" : "closed"}`}
            id="dropdown-imprimir-menu-item-faturado"
          >
            <MenuItem
              key="menu-item-faturado-imprimir-pedido"
              id="menu-item-faturado-imprimir-pedido"
              disabled={!canImprimirPedido}
              onClick={() =>
                props.onImprimirPedido!(props.itemRef.current!.uuidPedido)
              }
            >
              <ListItemIcon />
              <ListItemText>Pedido</ListItemText>
            </MenuItem>

            <MenuItem
              key={`menu-item-faturado-romaneioVenda-${props.itemRef.current!.uuidPedido}`}
              id={`menu-item-faturado-romaneioVenda-${props.itemRef.current!.uuidPedido}`}
              disabled={!canImprimirRomaneio}
              onClick={() =>
                props.onImprimirRomaneio!(props.itemRef.current!.uuidPedido)
              }
            >
              <ListItemIcon />
              <ListItemText>Romaneio</ListItemText>
            </MenuItem>

            {hasCrediario() && (
              <MenuItem
                key="menu-item-faturado-imprimir-crediario"
                id="menu-item-faturado-imprimir-crediario"
                disabled={!canImprimirCrediario}
                onClick={() =>
                  props.onImprimirCrediario!(
                    props.itemRef.current!.uuidPedido,
                    props.itemRef.current?.emissaoNota,
                  )
                }
              >
                <ListItemIcon />
                <ListItemText>Crediário</ListItemText>
              </MenuItem>
            )}

            {isAutorizada() && (
              <MenuItem
                key="menu-item-faturado-imprimir-dfe"
                id="menu-item-faturado-imprimir-dfe"
                disabled={!canImprimirDanfe}
                onClick={() =>
                  props.onImprimirDFE!(props.itemRef.current!.uuidNotaFiscal)
                }
              >
                <ListItemIcon />
                <ListItemText>DF-e</ListItemText>
              </MenuItem>
            )}
            <MenuItem
              key={`menu-item-faturado-etiqueta-volume-${props.itemRef.current!.uuidPedido}`}
              id={`menu-item-faturado-etiqueta-volume-${props.itemRef.current!.uuidPedido}`}
              disabled={!canImprimirEtiquetaVolume}
              onClick={() =>
                props.onImprimirEtiquetaVolume!(
                  props.itemRef.current!.uuidPedido,
                )
              }
            >
              <ListItemIcon />
              <ListItemText>Etiqueta Volume</ListItemText>
            </MenuItem>

            {isAutorizada() && configuracaoPoliticaVenda?.imprimirCupomTroca && (
              <MenuItem
                key="menu-item-faturado-imprimir-cupom-troca"
                id="menu-item-faturado-imprimir-cupom-troca"
                onClick={() =>
                  props.onImprimirCupomTroca!(props.itemRef.current!)
                }
              >
                <ListItemIcon />
                <ListItemText>Cupom de troca</ListItemText>
              </MenuItem>
            )}

            {!isNFCe() && (
              <MenuItem
                key="menu-item-faturado-etiqueta-simplificada"
                id="menu-item-faturado-etiqueta-simplificada"
                disabled={!canImprimirEtiquetaSimplificada}
                onClick={() =>
                  props.onImprimirEtiquetaSimplificada!(
                    props.itemRef.current!.chaveAcesso,
                  )
                }
              >
                <ListItemIcon />
                <ListItemText>Etiqueta DF-e simplificada</ListItemText>
              </MenuItem>
            )}
          </div>,
        ]}

      <MenuItem
        key="menu-item-aberto-visualizar-pedido"
        id="menu-item-aberto-visualizar-pedido"
        disabled={!canVisualizar}
        onClick={() =>
          props.onVisualizar(
            props.itemRef.current!.uuidPedido,
            props.itemRef.current!.numeroPedido,
          )
        }
      >
        <ListItemIcon>
          <Icon
            className="fa-solid fa-eye"
            sx={{ fontSize: "18px", width: "20px" }}
          />
        </ListItemIcon>
        <ListItemText>Visualizar</ListItemText>
      </MenuItem>

      {isEmProcessamento() && (
        <MenuItem
          key="menu-item-atualizar-situacao"
          id="menu-item-atualizar-situacao"
          disabled={!canAtualizarSituacao}
          onClick={() =>
            props.onAtualizarSituacao!(props.itemRef.current!.chaveAcesso)
          }
        >
          <ListItemIcon>
            <Icon
              className="fa-solid fa-rotate"
              sx={{ fontSize: "18px", width: "20px" }}
            />
          </ListItemIcon>
          <ListItemText>Atualizar situação</ListItemText>
        </MenuItem>
      )}

      {isAutorizada() && (
        <MenuItem
          key="menu-item-faturado-baixar-xml"
          id="menu-item-faturado-baixar-xml"
          disabled={!canBaixarXml}
          onClick={() => {
            props.onDownloadXML!(props.itemRef.current?.chaveAcesso ?? "");
          }}
        >
          <ListItemIcon>
            <FileDownload fontSize="small" />
          </ListItemIcon>

          <ListItemText>Baixar Xml</ListItemText>
        </MenuItem>
      )}

      {isAutorizada() && (
        <MenuItem
          key="menu-item-faturado-cancelar-dfe"
          id="menu-item-faturado-cancelar-dfe"
          disabled={!canCancelarDfe}
          onClick={props.onOpenCancelarDFe}
        >
          <ListItemIcon>
            <Icon className="fa-solid fa-xmark" sx={{ fontSize: "18px" }} />
          </ListItemIcon>
          <ListItemText>Cancelar DF-e</ListItemText>
        </MenuItem>
      )}

      {/* {
                isRejeitada() &&
                <MenuItem
                    key="menu-item-retransmitir"
                    id="menu-item-retransmitir"
                    onClick={undefined}
                    disabled
                >
                    <ListItemIcon>
                        <Icon className="fa-solid fa-xmark" sx={{ fontSize: "18px" }} />
                    </ListItemIcon>
                    <ListItemText>Retransmitir</ListItemText>
                </MenuItem>
            } */}

      {getConditionExcluirNota() && (
        <MenuItem
          key="menu-item-faturado-cancelar-dfe"
          id="menu-item-faturado-cancelar-dfe"
          disabled={!canExcluirNota}
          onClick={() =>
            props.onExcluirNota!(props.itemRef.current?.chaveAcesso ?? "")
          }
        >
          <ListItemIcon>
            <Icon className="fa-solid fa-xmark" sx={{ fontSize: "18px" }} />
          </ListItemIcon>
          <ListItemText>Excluir nota</ListItemText>
        </MenuItem>
      )}
    </MenuList>
  );
};

export default MenuItemFaturado;
